import React from "react";
import useOperationPdf from "../../hooks/useOperationPdf";

const OperationPdfController = React.memo(() => {
  useOperationPdf();
  return null;
});

export default OperationPdfController;
